import { COMMON_CONNECT_SRC_VALUES, COMMON_DEFAULT_SRC_VALUES, COMMON_FONT_SRC_VALUES, COMMON_FRAME_ANCESTORS_VALUES, COMMON_IMAGE_SRC_VALUES, COMMON_MEDIA_SRC_VALUES, COMMON_SCRIPT_SRC_VALUES, COMMON_STYLE_SRC_VALUES, } from "@snapchat/web-headers";
const IMAGE_SRC_VALUES = [
    ...COMMON_IMAGE_SRC_VALUES,
    // find more lenses images
    "https://lens.snapchat.com",
    // lens preview images and icons
    "https://bolt-gcdn.sc-cdn.net",
    // lens snapcodes
    "https://app.snapchat.com",
    // lens preview images
    "https://lens-storage.storage.googleapis.com",
    "https://community-lens.storage.googleapis.com",
    "https://lens-preview-storage.storage.googleapis.com",
];
const MEDIA_SRC_VALUES = [
    ...COMMON_MEDIA_SRC_VALUES,
    "https://lens.snapchat.com",
    // lens preview videos
    "https://lens-storage.storage.googleapis.com",
    "https://community-lens.storage.googleapis.com",
    // for testing
    "https://storage.googleapis.com",
];
const SCRIPT_SRC_VALUES = COMMON_SCRIPT_SRC_VALUES.concat(
// allow unsafe-eval in the dev server; it injects scripts for hot reloading
process.env.CSP_UNSAFE_EVAL ? ["'unsafe-eval'"] : []).concat([
    "https://lens.snapchat.com",
    // camera kit
    "https://api-kit.snapchat.com",
    "blob:",
    "'wasm-unsafe-eval'",
    // this is needed for older browsers that don't support wasm-unsafe-eval
    // security has approved this use case, see https://jira.sc-corp.net/browse/WEB-1910
    "'unsafe-eval'",
]);
const WORKER_SRC_VALUES = [
    "https://lens.snapchat.com",
    // camera kit (cross-origin worker)
    // web-sdk uses workers are used to run operations in a background thread for better performance
    // see http://go/lenswasmwebworkers
    "'self'",
    "blob:",
];
const CONNECT_SRC_VALUES = [
    ...COMMON_CONNECT_SRC_VALUES,
    "https://lens.snapchat.com",
    // camera kit
    // allow us to load the scripts used by the web-sdk
    "https://api-kit.snapchat.com",
    "https://*.sc-cdn.net",
];
const STYLE_SRC_VALUES = [...COMMON_STYLE_SRC_VALUES, "https://lens.snapchat.com"];
const FONT_SRC_VALUES = [...COMMON_FONT_SRC_VALUES, "https://lens.snapchat.com"];
export const POLICY_DIRECTIVES = {
    // fetch directives
    "worker-src": WORKER_SRC_VALUES,
    "connect-src": CONNECT_SRC_VALUES,
    "img-src": IMAGE_SRC_VALUES,
    "media-src": MEDIA_SRC_VALUES,
    "script-src": SCRIPT_SRC_VALUES,
    "style-src": STYLE_SRC_VALUES,
    "default-src": COMMON_DEFAULT_SRC_VALUES,
    "font-src": FONT_SRC_VALUES,
    // navigation directives
    "frame-ancestors": COMMON_FRAME_ANCESTORS_VALUES,
    // reporting directives - report-to has less support than report-uri, so use both:
    "report-uri": [],
    "report-to": [],
    // deprecated directives
    "block-all-mixed-content": [],
};
export const EMBED_POLICY_DIRECTIVES = {
    ...POLICY_DIRECTIVES,
    "frame-ancestors": ["*"],
};
